<template>
  <div class="echarts-contain">
    <div :id="id" class="o-echarts"></div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "verticalColumnar",
  props: {
    columnData: Array,
  },
  data() {
    return {
    //     columnData: [
    //     { product: ["Matcha Latte", "subTitle"], nums: 185 },
    //     { product: ["Milk Tea", "subTitle"], nums: 73 },
    //     { product: ["Cheese Cocoa", "subTitle"], nums: 65 },
    //     { product: ["Walnut Brownie", "subTitle"], nums: 53 },
    //   ]
      // id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
      id: 'chart',
      echartObj: null,
      option: {}
    };
  },
  mounted() {
      this.option = {
        tooltip: {
          show: false,
          position: 'inside',
          axisPointer: {
            type: 'none' // 去掉点击出现的横线
          },
          // trigger: "axis",
          trigger: "item",
          // triggerOn: 'click',
          formatter: function(params) {
            console.log('==========', params,)
              return `
              <div>${params.data.product[0]}: ${params.data.nums}起</div>
            `
            // return `
            //   <div>${params[0].data.product[0]}: ${params[0].data.nums}起</div>
            // `
          }
        },
        grid: {
          left: "0",
          top: "10",
          bottom: '0',
          right: '20'
        },
        xAxis: [
          {
            show: false,
          },
          {
            show: false,
          },
        ],
        yAxis: {
          type: "category",
          inverse: true,
          show: false,
        },

        series: [
          //亮色条 百分比
          {
            show: true,
            type: "bar",
            barGap: "-100%",
            barWidth: "20%",
            color: "#44C885",
            itemStyle: {
              normal: {
                barBorderRadius: 1,
              },
            },
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#36B374",
                  fontSize: 12,
                  fontWeight: "Medium",
                },
                position: "right",
              },
            },
            encode: {
              x: "nums",
            },
          },
          //年份
          {
            show: true,
            type: "bar",
            xAxisIndex: 1, //代表使用第二个X轴刻度
            barGap: "-100%",
            barWidth: "10%",
            itemStyle: {
              normal: {
                barBorderRadius: 200,
                color: "transparent",
              },
            },
            label: {
              normal: {
                show: true,
                position: [0, "-20"],
                formatter: function(params) {
                  return `{a|${params.dataIndex + 1}. ${params.name[0]}}  {b|${
                    params.name[1]
                  }}`;
                },
                // formatter: '{a|{b}}{b|{c}}',
                rich: {
                  a: {
                    fontSize: 14,
                    color: "#1E2226",
                    fontWeight: 400
                  },
                  b: {
                    fontSize: 12,
                    fontWeight: 400,
                    color: "#9DA0A4",
                  },
                },
              },
            },
            encode: {
              y: "product",
            },
          },
        ],
      }
    this.echartObj = echarts.init(document.getElementById(this.id));
    this.echartObj.setOption(this.setSeriesData(), true);
  },
  methods: {
    setSeriesData() {
      this.setOptions(
        "dataset",
        (() => {
          return {
            dimensions: ["product", "nums"],
            source: this.columnData
          };
        })()
      );
      return this.option;
    },

    setOptions(objKey, objVal) {
      if (
        this.option[objKey] &&
        typeof this.option[objKey] === "object" &&
        !Array.isArray(this.option[objKey])
      ) {
        this.option[objKey] = Object.assign(this.option[objKey], objVal);
      } else {
        this.option[objKey] = objVal;
      }
      //自动高度
      this.$set(this.option, objKey, this.option[objKey]);
      //55为每个数据的高度
      this.autoHeight = this.columnData.length * 60;
      this.echartObj.resize({height:this.autoHeight});
    }
  }
};
</script>

<style lang="less" scoped>
.echarts-contain {
  width: 100%;
  height: 100%;
  .o-echarts {
    width: 100%;
    height: 100%;
  }
  .o-echarts:last-child {
    z-index: 99 !important;
  }
}
.chart_tip span {
  opacity: 0.75;
  // background-color: #ff0000 !important;
}
</style>
